import { render, staticRenderFns } from "./returnOrderTable.vue?vue&type=template&id=6900c462"
import script from "./returnOrderTable.vue?vue&type=script&lang=js"
export * from "./returnOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports